import cookies from 'js-cookie';

export const shouldFetchConfigFromBackend = (): boolean =>
  !!cookies.get('development-fetch-config-from-backend');
